import * as tslib_1 from "tslib";
import { ApiService } from './api.service';
import { AppService } from "./app.service";
import { SignalRService } from './signalr.service';
import { RequestsType } from "../model/appConfig";
import { User } from "../model/user.model";
import * as Sentry from '@sentry/browser';
export class AuthService {
    constructor(apiService, signalRService, appService) {
        this.apiService = apiService;
        this.signalRService = signalRService;
        this.appService = appService;
        this.authenticated = false;
        this.user = (new User()).init();
        this.currentUser = (new User()).init();
        this.prevUser = (new User()).init();
        if (localStorage.getItem("user") && localStorage.getItem("currentuser")) {
            this.user = JSON.parse(localStorage.getItem("user"));
            this.currentUser = JSON.parse(localStorage.getItem("currentuser"));
            this.authenticated = true;
            // Set Sentry user for restored session
            Sentry.setUser({ id: this.currentUser.name, username: this.currentUser.name });
        }
        if (localStorage.getItem("prevuser")) {
            this.prevUser = JSON.parse(localStorage.getItem("prevuser"));
        }
    }
    authenticate(name, password) {
        return this.apiService.authenticate(name, password);
    }
    getChildUsers(name, password) {
        return this.apiService.getChildUsers(name, password);
    }
    saveAuthData(name, password, children, isChildUser, permissions) {
        if (!isChildUser) {
            this.user.name = name;
            this.user.password = password;
            this.user.children = children;
            this.user.active = true;
            if (permissions) {
                this.user.canControlSchedulerSwitch = permissions.canControlSchedulerSwitch;
                this.user.canEditWeeklyScheduler = permissions.canEditWeeklyScheduler;
                this.user.canEditSpecialDates = permissions.canEditSpecialDates;
            }
            localStorage.setItem("user", JSON.stringify(this.user));
            for (const field in this.user) {
                this.currentUser[field] = this.user[field];
            }
            localStorage.setItem("currentuser", JSON.stringify(this.currentUser));
        }
        else {
            this.currentUser.name = name;
            this.currentUser.password = password;
            this.currentUser.isChildUser = true;
            if (permissions) {
                this.currentUser.canControlSchedulerSwitch = permissions.canControlSchedulerSwitch;
                this.currentUser.canEditWeeklyScheduler = permissions.canEditWeeklyScheduler;
                this.currentUser.canEditSpecialDates = permissions.canEditSpecialDates;
            }
            localStorage.setItem("currentuser", JSON.stringify(this.currentUser));
        }
        this.authenticated = true;
        // Set Sentry user after successful login
        Sentry.setUser({ id: this.currentUser.name, username: this.currentUser.name });
    }
    logout() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.prevUser = this.currentUser.isChildUser ? this.user : this.currentUser;
            localStorage.setItem("prevuser", JSON.stringify(this.prevUser));
            this.user = (new User()).init();
            this.currentUser = (new User()).init();
            localStorage.removeItem("user");
            localStorage.removeItem("currentuser");
            this.authenticated = false;
            // Clear Sentry user on logout
            Sentry.setUser(null);
            try {
                const config = yield this.appService.getConfig();
                if (config.requestsType === RequestsType.SignalR) {
                    this.signalRService.disconnect();
                }
            }
            catch (error) {
                console.error('Failed to get config during logout:', error);
            }
        });
    }
    setCurrentUser(user) {
        this.currentUser = user;
        localStorage.setItem("currentuser", JSON.stringify(this.currentUser));
        // Update Sentry user when switching active user
        Sentry.setUser({ id: this.currentUser.name, username: this.currentUser.name });
    }
}
